import * as React from "react";
import copy from "copy-to-clipboard";
import { Container, InnerBox, CodeBtn, BtnWrapper } from "./styles";
import Toast from "../../../components/Toast";
import { LTReceiveToast } from "../../../components/LTReceiveToast";
import { px2rem } from "../../utils/css";
import { CouponType } from "../../../services/banner";
import { getLitbLangFn } from "../../../utils/language/index";
export const SuccessCode = "1000000";
class CouponCode extends React.Component {
    constructor(props) {
        var _a;
        super(props);
        this.onClickBtn = (code) => {
            copy(code);
            this.setState(() => {
                return {
                    showToast: true,
                };
            }, () => {
                setTimeout(() => {
                    this.setState(() => {
                        return {
                            showToast: false,
                        };
                    });
                }, 3000);
            });
        };
        this.getHeight = (size) => {
            switch (size) {
                case 1:
                    return px2rem(132);
                case 2:
                    return px2rem(93);
                case 3:
                    return px2rem(69);
                default:
                    return "0rem";
            }
        };
        this.getGrid = (size, rows = 0, length) => {
            switch (size) {
                case 1:
                    return `
				grid-template-columns:${px2rem(351)};
				grid-template-rows: ${px2rem(120)};
				`;
                case 2:
                    return `
				grid-column-gap: ${px2rem(9)};
				grid-row-gap:${px2rem(9)};
				grid-template-columns: repeat(2,${px2rem(171)});
				grid-template-rows:repeat(${rows},${px2rem(84)})};
				`;
                case 3:
                    return `
				grid-row-gap:${px2rem(9)};
				grid-template-columns: repeat(${length}, ${px2rem(140)});
				grid-column-gap: ${px2rem(6)};
				grid-template-rows:repeat(1,${px2rem(60)})};
					`;
                default:
                    return "0rem";
            }
        };
        this.onClickCopyBtn = (code) => {
            copy(code);
            this.setState(() => {
                return {
                    showToast: true,
                };
            }, () => {
                setTimeout(() => {
                    this.setState(() => {
                        return {
                            showToast: false,
                        };
                    });
                }, 3000);
            });
        };
        this.onClickReceiveCoupon = (code) => {
            this.props.getCoupons(code).then((res) => {
                this.setState(() => {
                    var _a;
                    return {
                        showToast: res.code === "1000000",
                        status: (_a = res.info) === null || _a === void 0 ? void 0 : _a.status,
                    };
                });
            });
        };
        this.renderCoupon = (coupons) => {
            return coupons.map((item, index) => {
                return (React.createElement(CodeBtn, { key: `${item.img}`, imgUrl: item.img, onClick: () => {
                        this.props.spmClick(index);
                        if (this.state.type === CouponType.CopyCoupon) {
                            this.onClickCopyBtn(item.code);
                        }
                        else {
                            this.onClickReceiveCoupon(item.code);
                        }
                    } }));
            });
        };
        this.renderToast = () => {
            var _a;
            if (this.state.type === CouponType.CopyCoupon) {
                return (React.createElement(Toast, { message: `${getLitbLangFn("Coupon successfully copied", (_a = this.props) === null || _a === void 0 ? void 0 : _a.language)}` }));
            }
            return (React.createElement(LTReceiveToast, { isMobile: true, status: this.state.status, lang: this.props.language, onClose: () => {
                    this.setState({ showToast: false });
                } }));
        };
        this.state = {
            showToast: false,
            columnSize: props.columnSize,
            coupons: props.coupons,
            status: -1,
            type: ((_a = this.props) === null || _a === void 0 ? void 0 : _a.type) || CouponType.CopyCoupon,
        };
    }
    render() {
        const { showToast, columnSize, coupons } = this.state;
        if (!!!coupons || coupons.length === 0) {
            return null;
        }
        return (React.createElement(Container, { id: this.props.positionId, columnSize: columnSize, height: this.getHeight(columnSize) },
            React.createElement(BtnWrapper, null,
                React.createElement(InnerBox, { columnSize: columnSize, grid: this.getGrid(columnSize, Math.ceil(coupons.length / +columnSize), coupons.length) }, this.renderCoupon(coupons))),
            showToast && this.renderToast()));
    }
}
export default CouponCode;
